(function($, MIKI_HD){
	const a = 'is-active';
	const $url = MIKI_HD.va.pathname;

	// ＜共通＞JSON取得 ---------------------------------------------------
	// CMSoD上最新5件のニュース取得用
	const getJSONlatestNews = () => {
		return $.getJSON('/hd/ajax/latest_news_list.json');
	};
	// CMSoD上の最新ニュースの西暦取得用
	const getJSONlatestYear = () => {
		return $.getJSON('/hd/ajax/latest_news_year.json');
	};
	// CMSoD上の西暦ごとのニュースの取得用
	const getJSONnewsList = (_year) => {
		return $.getJSON(`/hd/ajax/${_year}/news_list.json`);
	};
	// プロネクサス側のjsonp取得用
	const getJSONirList = () => {
		return $.ajax({
			type: 'GET',
			url: 'https://ssl4.eir-parts.net/V4Public/eir/7455/ja/announcement/announcement_6.js',
			dataType: 'jsonp',
			jsonp: 'callback',
			jsonpCallback: 'eolparts_announcement_6'
		});
	};

	// <共通>---------------------------------------------------------------
	// 現在日時
	const thisDate = new Date();

	const $output = $('.js-newsOutput');
	const $selectYear = $('.js-selectYear');
	const $loading = $('.news-idx-loading');
	const $newsBlock = $('.news-idx-newsBlock');

	// ニュースの要素仮定義
	let newsDate,
		newsCat,
		newsAnchor,
		newsType,
		newsCatTag,
		newsTit,
		newsFileSize,
		newsFileExt,
		newsFileIcon,
		newsNewFlag;

	// ニュースラベル
	const labelIr = '<span class="ir">IR情報</span>';
	const labelNotice = {
		cat: 'notice',
		html: '<span class="news">お知らせ</span>'
	};
	const labelPress = {
		cat: 'pressrelease',
		html: '<span class="hd_press">プレスリリース</span>'
	};

	// newアイコン
	const newsNewHTML = '<span class="mod-newsList-new">NEW</span>';

	// ニュース内容出力
	let newsHTMLcreate = (_date, _tag, _new, _anchor, _tit, _fileIcon) => {
		$(`<li class="mod-newsList-li"><div class="mod-newsList-li-inner">
		<span class="mod-newsList-date">${_date}</span>
		<span class="mod-newsList-cat">${_tag}</span>
		<span class="mod-newsList-newWrap">${_new}</span>
		${_anchor}
		<span class="mod-newsList-title">${_tit}</span>
		${_fileIcon}
		</a></div></li>`).appendTo($output);
	};

	// 出力年号------------------------------------------------------
	// 最古年号
	const oldestYear = 2017;
	let latestYear;
	// プロネクサス側のニュースの最新年号取得用
	const getMax =(arr, prop) => {
		let max;
		for(let i=0; i<arr.length; i++) {
			if(!max || parseInt(arr[i][prop]) > parseInt(max[prop]))
				max = arr[i];
		}
		return max;
	};

	// ファイルサイズ変換
	// プロネクサスデータ用（KB、「,」有り）
	const bytesToSizeIR = (bytes) => {
		const sizes = ['KB', 'MB', 'GB'];
		if(bytes.replace(/,/g, '') === 0) return '0 Byte';
		let i = parseInt(Math.floor(Math.log(bytes.replace(/,/g, '')) / Math.log(1024)));
		return Math.floor(bytes.replace(/,/g, '') / Math.pow(1024, i)* Math.pow(10, 1)) / Math.pow(10, 1) + sizes[i];
	};
	// CMSoDデータ用（byte、「,」無し）
	const bytesToSize = (bytes) => {
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		if(bytes === 0) return '0 Byte';
		let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		return Math.floor(bytes / Math.pow(1024, i)* Math.pow(10, 1)) / Math.pow(10, 1) + sizes[i];
	};


	// <Topページ、IR・投資家情報共通>
	if($url === '/hd/' || $url === '/hd/index.html' || $url === '/hd/investor/' || $url === '/hd/investor/index.html') {

		getJSONirList().done((data) => {
			let irNewsList = data.item;

			// 最新5件を描画
			let latestNewsArr = [];
			let latestIrNews5 = irNewsList.splice(0, 5);
			for(let i=0; i<latestIrNews5.length; i++) {
				let thisDate = latestIrNews5[i].date.replace(/[^0-9]/g, '');
				let thisId = latestIrNews5[i].guid;
				latestNewsArr.push({ id:thisId, datetime:thisDate });
			}

			getJSONlatestNews().done((dataCms) => {
				let cmsNewsList = dataCms.rt_bn_news_list;
				for(let i=0; i<cmsNewsList.length; i++) {
					let thisDate = cmsNewsList[i].cf_n_date.replace(/[^0-9]/g, '');
					let thisId = cmsNewsList[i]._key;
					latestNewsArr.push({ id:thisId, datetime:thisDate });
				}

				// 各新着5件(合計10件)を統合して日付順にソート
				latestNewsArr.sort(
					function(x, y){
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if(xDate > yDate) return(-1);
						if(xDate < yDate) return(1);
						return 0;
					}
				);

				// 統合後の最新5件を描画
				const latestNewsArr5 = latestNewsArr.splice(0, 5);

				for(let i=0; i<latestNewsArr5.length; i++) {

					// プロネクサス
					for(let j=0; j<latestIrNews5.length; j++) {
						if(latestIrNews5[j].guid === latestNewsArr5[i].id) {
							newsDate = latestIrNews5[j].format_date;
							newsCatTag = labelIr;
							newsAnchor = `<a href="${latestIrNews5[j].link}" target="${latestIrNews5[j].new_target}" rel="noopener" class="mod-newsList-a">`;
							newsTit = latestIrNews5[j].title;
							newsFileSize = bytesToSizeIR(latestIrNews5[j].file_size);
							newsFileExt = latestIrNews5[j].type;

							// newsFileIcon出し分け
							if (newsFileExt === 'pdf' && newsFileSize) {
								newsFileIcon = `<i class="imgicon imgicon-pdf"></i><span>(${newsFileSize})</span>`;
							} else if (newsFileSize) {
								newsFileIcon = `<span>(${newsFileSize})</span>`;
							} else {
								newsFileIcon = '';
							}

							// newアイコン出し分け（２週間以内のニュースのみアイコン付与）
							let thisNewsDate = new Date(newsDate);
							if(Math.ceil((thisDate - thisNewsDate) / 86400000) <= 14) {
								newsNewFlag = newsNewHTML;
							} else {
								newsNewFlag = '';
							}

							// ニュース描画
							newsHTMLcreate(newsDate, newsCatTag, newsNewFlag, newsAnchor, newsTit, newsFileIcon);
						}
					}

					// CMSoD
					for(let k=0; k<cmsNewsList.length; k++) {
						let _key = cmsNewsList[k]._key;
						if(_key === latestNewsArr5[i].id) {
							newsDate = cmsNewsList[k].rt_cf_n_date.content;
							newsTit = cmsNewsList[k].cf_n_title;
							newsType = 	cmsNewsList[k].cf_n_type;

							// newsCatTag出し分け
							let dataCat = cmsNewsList[k].cf_n_category.cf_nc_code;
							if(dataCat === 'hd_notice') {
								newsCat = labelNotice.cat;
								newsCatTag = labelNotice.html;
							} else if(dataCat === 'hd_press') {
								newsCat = labelPress.cat;
								newsCatTag = labelPress.html;
							}

							// newsFileIcon、newsLink、newsTarget出し分け
							let dataFile = cmsNewsList[k].cf_n_attachment_file;
							if(dataFile !== '') {
								newsFileSize = bytesToSize(cmsNewsList[k].cf_n_attachment_file_size);
								newsFileExt = dataFile.split('.')[dataFile.split('.').length -1];
								newsAnchor = `<a href="/hd/news/news_file/file/${dataFile}" target="_blank" rel="noopener" class="mod-newsList-a">`;

								if (newsFileExt === 'pdf' && newsFileSize) {
									newsFileIcon = `<i class="imgicon imgicon-pdf"></i><span>(${newsFileSize})</span>`;
								} else if (newsFileSize) {
									newsFileIcon = `<span>(${newsFileSize})</span>`;
								} else {
									newsFileIcon = '';
								}
							} else {
								newsFileIcon = '';
								if(newsType === 5) {
									newsAnchor = '<a href="" style="pointer-events:none;cursor:default;text-decoration:none;" class="mod-newsList-a">';
								} else if(newsType === 3) {
									newsAnchor = `<a href="${cmsNewsList[k].cf_n_url}" target="_blank" rel="noopener" class="mod-newsList-a">`;
								} else {
									if(dataCat === 'press') {
										newsAnchor = `<a href="https://www.paris-miki.co.jp/pressrelease/detail/${_key}.html" target="_blank" rel="noopener" class="mod-newsList-a">`;
									} else {
										newsAnchor = `<a href="/hd/news/${newsDate.split('.')[0]}/${newsCat}/detail/${_key}.html" target="_self" class="mod-newsList-a">`;
									}
								}
							}

							// newアイコン出し分け（２週間以内のニュースのみアイコン付与）
							let thisNewsDate = new Date(newsDate);
							if(Math.ceil((thisDate - thisNewsDate) / 86400000) <= 14) {
								newsNewFlag = newsNewHTML;
							} else {
								newsNewFlag = '';
							}

							// ニュース描画
							newsHTMLcreate(newsDate, newsCatTag, newsNewFlag, newsAnchor, newsTit, newsFileIcon);
						}
					}
				}
			});
		});
	}

	// <ニュースtop> 最新の西暦ニュース一覧へリダイレクト
	if($url === '/hd/news/' || $url === '/hd/news/index.html') {
		getJSONirList().done((data) => {
			// プロネクサス側の最新年号
			let extY = getMax(data.item, 'format_date').format_date.split('.')[0];
			// CMSoD側の最新年号
			getJSONlatestYear().done((data) => {
				let cmsY = data.rt_bn_news_list[0].rt_latest_year;
				latestYear = Math.max(extY, cmsY);
				location.href = `/hd/news/${latestYear}/`;
			});
		});
	}

	// <西暦ニュース一覧>
	if($selectYear.length) {
		const $cat = $url.split('/')[4];
		const $year = $url.split('/')[3];

		// カテゴリのカレント
		if($cat === '' || $cat === 'index.html') {
			$('.news-idx-nav-a*[data-cat=all]').addClass(a);
		} else {
			$(`.news-idx-nav-a*[data-cat=${$cat}]`).addClass(a);
		}

		$('.news-idx-nav-a').each((idx, ele) => {
			let thisCat = $(ele).attr('data-cat');
			if(thisCat === 'all') {
				$(ele).attr('href', `/hd/news/${$year}/`);
			} else {
				$(ele).attr('href', `/hd/news/${$year}/${thisCat}/`);
			}
		});

		getJSONirList().done((data) => {
			// プロネクサス側の最新年号
			let irNewsList = data.item;
			let extY = getMax(irNewsList, 'format_date').format_date.split('.')[0];
			// CMSoD側の最新年号
			getJSONlatestYear().done((data) => {
				let cmsY = data.rt_bn_news_list[0].rt_latest_year;
				latestYear = Math.max(extY, cmsY);

				// 年号プルダウン作成
				for(let i=oldestYear; i<latestYear+1; i++) {
					if($url.indexOf(i) !== -1) {
						$selectYear.prepend(`<option value="${i}" selected="selected">${i}年</option>`);
					} else {
						$selectYear.prepend(`<option value="${i}">${i}年</option>`);
					}
				}
			});

			// irニュース一覧------------------------------------------
			if($cat === 'ir') {
				if(irNewsList.length !== 0) {
					$('.rt_bn_news_list_is_0').remove();

					for(let i=0; i<irNewsList.length; i++) {
						newsDate = irNewsList[i].format_date;
						newsCatTag = labelIr;
						newsAnchor = `<a href="${irNewsList[i].link}" target="${irNewsList[i].new_target}" rel="noopener" class="mod-newsList-a">`;
						newsTit = irNewsList[i].title;
						newsFileSize = bytesToSizeIR(irNewsList[i].file_size);
						newsFileExt = irNewsList[i].type;

						// newsFileIcon出し分け
						if (newsFileExt === 'pdf' && newsFileSize) {
							newsFileIcon = `<i class="imgicon imgicon-pdf"></i><span>(${newsFileSize})</span>`;
						} else if (newsFileSize) {
							newsFileIcon = `<span>(${newsFileSize})</span>`;
						} else {
							newsFileIcon = '';
						}

						// newアイコン出し分け（２週間以内のニュースのみアイコン付与）
						let thisNewsDate = new Date(newsDate);
						if(Math.ceil((thisDate - thisNewsDate) / 86400000) <= 14) {
							newsNewFlag = newsNewHTML;
						} else {
							newsNewFlag = '';
						}

						// ニュース描画
						if(newsDate.split('.')[0] === $year) {
							newsHTMLcreate(newsDate, newsCatTag, newsNewFlag, newsAnchor, newsTit, newsFileIcon);
						}
					}

					setTimeout(function(){
						$loading.remove();
						$newsBlock.addClass(a);
						$('.footer').css('opacity', 1);
					}, 300);

				} else {
					$output.remove();
				}

			} else if($cat === '' || $cat === 'index.html') {
				// 年号ごとのニュース一覧
				let allNewsArr = [];

				for(let i=0; i<irNewsList.length; i++) {
					if(irNewsList[i].date.split('/')[0] === $year) {
						let thisDate = irNewsList[i].date.replace(/[^0-9]/g, '');
						let thisId = irNewsList[i].guid;
						allNewsArr.push({ id:thisId, datetime:thisDate });
					}
				}

				getJSONnewsList(`${$year}`).done((dataCms) => {
					let cmsNewsList = dataCms.rt_bn_news_list;

					for(let i=0; i<cmsNewsList.length; i++) {
						let thisDate = cmsNewsList[i].cf_n_date.replace(/[^0-9]/g, '');
						let thisId = cmsNewsList[i]._key;
						allNewsArr.push({ id:thisId, datetime:thisDate });
					}

					// 統合して日付順にソート
					allNewsArr.sort(
						function(x, y){
							let xDate = x['datetime'];
							let yDate = y['datetime'];
							if(xDate > yDate) return(-1);
							if(xDate < yDate) return(1);
							return 0;
						}
					);

					for(let i=0; i<allNewsArr.length; i++) {

						// プロネクサス
						for(let j=0; j<irNewsList.length; j++) {
							if(irNewsList[j].guid === allNewsArr[i].id) {
								newsDate = irNewsList[j].format_date;
								newsCatTag = labelIr;
								newsAnchor = `<a href="${irNewsList[j].link}" target="${irNewsList[j].new_target}" rel="noopener" class="mod-newsList-a">`;
								newsTit = irNewsList[j].title;
								newsFileSize = bytesToSizeIR(irNewsList[j].file_size);
								newsFileExt = irNewsList[j].type;

								// newsFileIcon出し分け
								if (newsFileExt === 'pdf' && newsFileSize) {
									newsFileIcon = `<i class="imgicon imgicon-pdf"></i><span>(${newsFileSize})</span>`;
								} else if (newsFileSize) {
									newsFileIcon = `<span>(${newsFileSize})</span>`;
								} else {
									newsFileIcon = '';
								}

								// newアイコン出し分け（２週間以内のニュースのみアイコン付与）
								let thisNewsDate = new Date(newsDate);
								if(Math.ceil((thisDate - thisNewsDate) / 86400000) <= 14) {
									newsNewFlag = newsNewHTML;
								} else {
									newsNewFlag = '';
								}

								// ニュース描画
								newsHTMLcreate(newsDate, newsCatTag, newsNewFlag, newsAnchor, newsTit, newsFileIcon);
							}
						}

						// CMSoD
						for(let k=0; k<cmsNewsList.length; k++) {
							let _key = cmsNewsList[k]._key;
							if(_key === allNewsArr[i].id) {
								newsDate = cmsNewsList[k].rt_cf_n_date.content;
								newsTit = cmsNewsList[k].cf_n_title;
								newsType = 	cmsNewsList[k].cf_n_type;

								// newsCatTag出し分け
								let dataCat = cmsNewsList[k].cf_n_category.cf_nc_code;
								if(dataCat === 'hd_notice') {
									newsCat = labelNotice.cat;
									newsCatTag = labelNotice.html;
								} else if (dataCat === 'hd_press') {
									newsCat = labelPress.cat;
									newsCatTag = labelPress.html;
								}

								// newsFileIcon、newsLink、newsTarget出し分け
								let dataFile = cmsNewsList[k].cf_n_attachment_file;
								if(dataFile !== '') {
									newsFileSize = bytesToSize(cmsNewsList[k].cf_n_attachment_file_size);
									newsFileExt = dataFile.split('.')[dataFile.split('.').length -1];
									newsAnchor = `<a href="/hd/news/news_file/file/${dataFile}" target="_blank" rel="noopener" class="mod-newsList-a">`;

									if (newsFileExt === 'pdf' && newsFileSize) {
										newsFileIcon = `<i class="imgicon imgicon-pdf"></i><span>(${newsFileSize})</span>`;
									} else if (newsFileSize) {
										newsFileIcon = `<span>(${newsFileSize})</span>`;
									} else {
										newsFileIcon = '';
									}
								} else {
									newsFileIcon = '';
									if(newsType === 5) {
										newsAnchor = '<a href="" style="pointer-events:none;cursor:default;text-decoration:none;" class="mod-newsList-a">';
									} else if(newsType === 3) {
										newsAnchor = `<a href="${cmsNewsList[k].cf_n_url}" target="_blank" class="mod-newsList-a">`;
									} else {
										if(dataCat === 'press') {
											newsAnchor = `<a href="https://www.paris-miki.co.jp/pressrelease/detail/${_key}.html" target="_blank" rel="noopener" class="mod-newsList-a">`;
										} else {
											newsAnchor = `<a href="/hd/news/${newsDate.split('.')[0]}/${newsCat}/detail/${_key}.html"
											 target="_self" class="mod-newsList-a">`;
										}
									}
								}

								// newアイコン出し分け（２週間以内のニュースのみアイコン付与）
								let thisNewsDate = new Date(newsDate);
								if(Math.ceil((thisDate - thisNewsDate) / 86400000) <= 14) {
									newsNewFlag = newsNewHTML;
								} else {
									newsNewFlag = '';
								}

								// ニュース描画
								newsHTMLcreate(newsDate, newsCatTag, newsNewFlag, newsAnchor, newsTit, newsFileIcon);
							}
						}

					}

					setTimeout(function(){
						$loading.remove();
						$newsBlock.addClass(a);
						$('.footer').css('opacity', 1);
					}, 300);
				});

			}
		});

		// 年号遷移
		$selectYear.on('change', (e) => {
			location.href = `/hd/news/${$(e.target).val()}/`;
		});

		// 「お知らせ」「プレスリリース」
		if ($cat === 'notice' || $cat === 'pressrelease') {
			// 「すべて」「IR情報」用のニュースリストを削除
			$output.remove();

			// ファイルサイズを変換
			$('.rt_cf_n_attachment_file_size').each((idx, ele) => {
				let cvFileSize = bytesToSize($(ele).text());
				$(ele).text(`(${cvFileSize})`);
			});

			setTimeout(function(){
				$loading.remove();
				$newsBlock.addClass(a);
				$('.footer').css('opacity', 1);
			}, 300);
		}
	}

})(window.jQuery, window.MIKI_HD);
